import { ContributorType } from '@shared-models';

import {
  IContributorCompanyType,
  IContributorType,
} from 'src/app/@interfaces/contributorTypes.interface';

export class ContributorTypeMapper {
  static mapper(
    contributorType: IContributorCompanyType | IContributorType,
  ): ContributorType {
    return {
      description: contributorType.description,
      dian_code: contributorType.dian_code,
    };
  }
}
